import React from 'react';
import type { BoxProps } from '@withjoy/joykit';
import { Accordion, Box } from '@withjoy/joykit';
import { SkeletonText } from '@shared/components/Skeleton';
import { useRefinementsPanelProvider } from '../../../RefinementsPanel';
import { styles, StyledSkeletonFilterHeader } from './RefinementFacetBase.styles';
export interface RefinementFilterBaseProps extends BoxProps<'span'> {
  title: string;
  groupCode: string;
  onClick?: (e: React.MouseEvent) => void;
  children: MaybeRenderProp<{ triggerAnimation: () => void }>;
}

const AccordionItemContainer: typeof Accordion.Item = props => {
  const { children } = props;
  return <Accordion.Item as="section">{children}</Accordion.Item>;
};

export const RefinementFacetBase = (props: RefinementFilterBaseProps) => {
  const { children, title, groupCode } = props;
  const { getActiveFilterCountByGroupCode } = useRefinementsPanelProvider();
  const groupCodeSubtotalFilters = getActiveFilterCountByGroupCode(groupCode);
  return (
    <AccordionItemContainer>
      {({ isExpanded }) => {
        return (
          <>
            <Accordion.Button>
              <Box
                flex="1 1 0%"
                __css={styles.filterHeaderStyle}
              >
                {title}
              </Box>
              {isExpanded || groupCodeSubtotalFilters < 1 ? (
                <Box __css={styles.accordionIconStyle}>
                  <Accordion.Icon />
                </Box>
              ) : (
                <Box __css={styles.subtotalFiltersStyle}>{groupCodeSubtotalFilters}</Box>
              )}
            </Accordion.Button>
            <Accordion.Panel paddingX={0}>{children}</Accordion.Panel>
          </>
        );
      }}
    </AccordionItemContainer>
  );
};

RefinementFacetBase.Skeleton = (props: BoxProps) => {
  const { children } = props;

  return (
    <AccordionItemContainer>
      <Accordion.Button __css={styles.accordionButton}>
        <StyledSkeletonFilterHeader
          flex="1 1 0%"
          __css={styles.filterHeader}
        >
          <SkeletonText
            rows={1}
            skeletonHeight={'20px'}
            width="60%"
          />
        </StyledSkeletonFilterHeader>
        <Accordion.Icon />
      </Accordion.Button>
      <Accordion.Panel paddingX={0}>{children}</Accordion.Panel>
    </AccordionItemContainer>
  );
};
